import { DateTimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import saveAs from 'file-saver';
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import Arquivo from "model/arquivo/Arquivo";
import Atividade from "model/gestao/atividades/Atividade";
import AtividadeApontamento from "model/gestao/atividades/AtividadeApontamento";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FileUpload, FileUploadSelectEvent } from "primereact/fileupload";
import { InputTextarea } from "primereact/inputtextarea";
import { Panel } from "primereact/panel";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Lightbox from "react-image-lightbox";
import 'react-image-lightbox/style.css';
import AtividadeApontamentoService from "service/gestao/atividades/AtividadeApontamentoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { pessoaCompleteMethod, pessoaItemTemplate } from "utils/autocompleteUtils";

type Props = {
    isModal?: boolean;
    onSave?: (model: AtividadeApontamento) => void;
    id?: number;
}

const atividadeApontamentoService = new AtividadeApontamentoService();
const usuarioLogadoService = new UsuarioLogadoService();
export default function AtividadeApontamentoCadastro(props: Props) {

    const { msgAlerta } = useToastContext();

    const { setError, formState: { errors }, register, clearErrors, control } = useForm();

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [atividades, setAtividades] = useState<Atividade[]>([]);
    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [clientesFiltrados, setClientesFiltrados] = useState<any[]>([]);
    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);

    const [photoIndex, setPhotoIndex] = useState<number>(0);
    const [photoOpen, setPhotoOpen] = useState<boolean>(false);
    const [imagensExibir, setImagensExibir] = useState<Arquivo[]>([]);

    useEffect(() => {

        atividadeApontamentoService.tecnicos().then(resposta => {
            setUsuarios(resposta);
        }).catch((error) => {
            console.error(error);
        });

        atividadeApontamentoService.atividades().then(resposta => {
            setAtividades(resposta);
        }).catch((error) => {
            console.error(error);
        });

        atividadeApontamentoService.clientes().then(resposta => {
            setClientes(resposta);
        }).catch((error) => {
            console.error(error);
        });

    }, [])

    const [apontamento, setApontamento] = useState<AtividadeApontamento>(new AtividadeApontamento(0, null, '', { id: usuarioLogadoService.getUsuario().id, nome: usuarioLogadoService.getUsuario().nome } as Usuario));
    const [anexos, setAnexos] = useState<any[]>([]);

    function validar() {

        if (apontamento.usuario === null) {
            setError("usuario", { type: "manual", message: "Usuário é obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (apontamento.pessoa === null) {
            setError("cliente", { type: "manual", message: "Cliente é obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (apontamento.pessoa?.codigo === null) {
            setError("cliente", { type: "manual", message: "Cliente inválido" }, { shouldFocus: true })
            return false;
        }

        if (apontamento.atividade === null) {
            setError("atividade", { type: "manual", message: "Atividade é obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (apontamento.dataInicio === null || apontamento.dataInicio === undefined) {
            setError("dataInicio", { type: "manual", message: "Data de início é obrigatória" }, { shouldFocus: true })
            return false;
        }

        if (apontamento.dataFim === null || apontamento.dataFim === undefined) {
            setError("dataFim", { type: "manual", message: "Data de fim é obrigatória" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    function validarPersonalizado() {

        if (dayjs(apontamento.dataInicio).isAfter(dayjs(apontamento.dataFim))) {
            msgAlerta('Apontamento', 'A data final não pode ser menor que a data inicial!');
            return false;
        }

        return true;
    }

    function removerAnexoExistente(anexo: Arquivo) {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente remover este anexo?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => confirmRemoverAnexoExistente(anexo),
        });
    }

    function confirmRemoverAnexoExistente(anexo: Arquivo) {
        anexo.ativo = false;
        setApontamento(JSON.parse(JSON.stringify(apontamento)));
    }

    function clickImagem(index: number, imagens: Arquivo[]) {
        setImagensExibir(imagens);
        setTimeout(() => {
            setPhotoIndex(index);
            setPhotoOpen(true);
        }, 100);
    }

    function onUploadAnexo(event: FileUploadSelectEvent) {
        try {
            if (event.files && event.files.length) {
                const anexosLocal = [...anexos];
                for (let index = 0; index < event.files.length; index++) {
                    const file = event.files[index];
                    const idAnexo = new Date().getTime() * -1;
                    anexosLocal.push({ id: idAnexo, nome: file.name, data: null, file });
                }
                setAnexos(anexosLocal);
                event.files = [];
            }
        } catch (error) {
            console.error(error);
        }
    }

    function removerAnexo(anexo: any) {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente remover este anexo?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => confirmRemoverAnexo(anexo),
        });
    }

    function confirmRemoverAnexo(anexo: any) {
        let anexosLocal = JSON.parse(JSON.stringify(anexos));;
        anexosLocal = anexosLocal.filter((o: any, i: any) => o.id !== anexo.id);
        setAnexos(anexosLocal);
    }

    function getFormData() {
        const data = new FormData();
        data.append('apontamento', JSON.stringify(apontamento));

        if (anexos && anexos.length > 0) {
            for (let i = 0; i < anexos.length; i++) {
                data.append('files', JSON.stringify({
                    name: anexos[i].name,
                    type: anexos[i].type,
                    file: anexos[i].file,
                    uri: anexos[i].uri,
                }));
            }
            data.getAll('files').forEach((file: any) => {
                console.log(file)
            })
        }
        return data;
    }

    return (

        <BaseCadastro model={apontamento}
            novoCadastro
            id={props.id}
            isModal={props.isModal}
            onSave={props.onSave}
            getNewModel={() => new AtividadeApontamento()}
            getModel={() => {

                const data = getFormData();
                return data;

            }}
            service={atividadeApontamentoService} setModel={(value: AtividadeApontamento) => {
                setAnexos([]);
                if (value.id) {
                    setApontamento(value);
                } else {
                    setApontamento(prev => ({ ...prev, id: 0 }));
                }
            }} validarPersonalizado={() => validarPersonalizado()} validar={() => validar()} urlService="/apontamento" pathCadastro="/apontamento" tituloPagina={'Apontamentos'}>

            {photoOpen && imagensExibir && imagensExibir.length > 0 && (
                <Lightbox
                    mainSrc={imagensExibir[photoIndex].url}
                    nextSrc={imagensExibir[(photoIndex + 1) % imagensExibir.length].url}
                    prevSrc={imagensExibir[(photoIndex + imagensExibir.length - 1) % imagensExibir.length].url}
                    onCloseRequest={() => setPhotoOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + imagensExibir.length - 1) % imagensExibir.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % imagensExibir.length)
                    }
                />
            )}

            {!props.isModal ? <div className="row">
                <Label className="col col-sm-12" obrigatorio>Técnico</Label>
                <div className="col-sm-12">
                    <Controller name="usuario" control={control} render={({ field }) => (

                        <Dropdown
                            focusInputRef={field.ref}
                            dataKey={"id"}
                            className={errors.usuario ? "p-invalid" : ""}
                            options={usuarios}
                            filter
                            optionLabel="nome"
                            placeholder="Selecione"
                            value={apontamento.usuario}
                            style={{ width: '100%' }}
                            onChange={(e) => {
                                clearErrors("usuario")
                                setApontamento({ ...apontamento, usuario: e.value as Usuario })
                            }
                            }
                        />
                    )} />
                </div>
                {errors.usuario && errors.usuario.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.usuario?.message as string}</span> : null}
            </div> : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Cliente</Label>
                <div className="col-sm-12">
                    <Controller name="cliente" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            dropdown
                            value={apontamento.pessoa}
                            placeholder="Selecione um Cliente"
                            style={{ width: '30%' }}
                            className={errors.cliente ? "p-invalid" : ""}
                            field="nome"
                            itemTemplate={(item: Pessoa) => pessoaItemTemplate(item)}
                            suggestions={clientesFiltrados}
                            completeMethod={(e) => {
                                let filtered: Pessoa[] = pessoaCompleteMethod(clientes, e.query);
                                setClientesFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                clearErrors("cliente")

                                let apontamentoLocal = JSON.parse(JSON.stringify(apontamento));

                                if (!e.target.value) {
                                    apontamentoLocal.pessoa = null;
                                } else if (typeof e.target.value == "string") {
                                    let pessoa = new Pessoa();
                                    pessoa.nome = e.target.value;
                                    apontamentoLocal.pessoa = pessoa;
                                } else {
                                    apontamentoLocal.pessoa = e.target.value;
                                }

                                setApontamento(apontamentoLocal);
                            }}
                        />
                    )} />
                </div>
                {errors.cliente && errors.cliente.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.cliente?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Atividade</Label>
                <div className="col-sm-12">
                    <Controller name="atividade" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.atividade ? "p-invalid" : ""}
                            options={atividades}
                            optionLabel="nome"
                            placeholder="Selecione"
                            value={apontamento.atividade}
                            style={{ width: '100%' }}
                            onChange={(e) => {
                                clearErrors("atividade")
                                setApontamento({ ...apontamento, atividade: e.value as Atividade })
                            }
                            }
                        />
                    )} />
                </div>
                {errors.atividade && errors.atividade.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.atividade?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Data/Hora Início</Label>
                <div className="col-sm-12">
                    <Controller name="dataInicio" control={control} render={({ field }) => (

                        <DateTimePicker
                            inputRef={field.ref}
                            value={dayjs(apontamento.dataInicio)}
                            ampm={false}
                            slotProps={{
                                popper: {
                                    disablePortal: true,
                                },
                            }}
                            onChange={value => {
                                clearErrors("dataInicio")
                                setApontamento({ ...apontamento, dataInicio: value?.toDate() || null })
                            }}
                        />
                    )} />
                </div>
                {errors.dataInicio && errors.dataInicio.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataInicio?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Data/Hora Fim</Label>
                <div className="col-sm-12">
                    <Controller name="dataFim" control={control} render={({ field }) => (

                        <DateTimePicker
                            inputRef={field.ref}
                            value={dayjs(apontamento.dataFim)}
                            slotProps={{
                                popper: {
                                    disablePortal: true,
                                },
                            }}
                            ampm={false}
                            onChange={value => {
                                clearErrors("dataFim")
                                setApontamento({ ...apontamento, dataFim: value?.toDate() || null })
                            }}
                        />
                    )} />
                </div>
                {errors.dataFim && errors.dataFim.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataFim?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Descrição</Label>
                <div className="col-sm-12">
                    <InputTextarea value={apontamento.descricao} onChange={(e) => setApontamento({ ...apontamento, descricao: e.target.value })} rows={4} style={{ width: '100%' }} />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <Panel header={`Anexos/Imagens`} toggleable={true} collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}>
                        <div className="col-sm-12">

                            <div className="row">

                                <div className="col-sm-12">
                                    <FileUpload mode="basic" name="anexoscontato" accept="image/*" maxFileSize={5242880} multiple={true} onSelect={(event) => onUploadAnexo(event)} auto={true} chooseLabel="Adicionar anexo" />
                                </div>
                                {anexos && anexos.length > 0 ?
                                    <div className="col-sm-12">
                                        <DataTable
                                            header='Novos anexos'
                                            value={anexos}
                                            emptyMessage='Nenhum anexo'
                                        >
                                            <Column field="nome" header="Nome" className='coluna-nome'></Column>
                                            <Column
                                                style={{ width: 60 }}
                                                body={(rowData) => <>
                                                    <Button type="button" icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => removerAnexo(rowData)} />
                                                </>} />
                                        </DataTable>
                                    </div>
                                    : null}

                                <div className="col-sm-12" style={{ marginTop: 8 }}>
                                    <DataTable
                                        header={null}
                                        value={apontamento.arquivos}
                                        emptyMessage='Nenhum anexo'
                                    >
                                        <Column field="nome" header="Anexos"
                                            className='coluna-nome'
                                            body={(rowData) => rowData.id > 0 ? rowData.remover ?
                                                <span><s>{rowData.nome}</s></span>
                                                : <a
                                                    style={{ color: '#3CA4FF', textDecoration: 'underline', textDecorationColor: '#3CA4FF', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        fetch(rowData.url)
                                                            .then(res => res.blob())
                                                            .then(blob => saveAs(blob, rowData.nome))
                                                            .catch(e => {
                                                                console.error(e)
                                                            });
                                                        return false;
                                                    }}>{rowData.nome}</a> : rowData.nome}>
                                        </Column>
                                        <Column
                                            style={{ width: 60 }}
                                            body={(rowData) => <>
                                                {rowData.remover ? null :
                                                    <Button type="button" icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => removerAnexoExistente(rowData)} />
                                                }
                                            </>}>
                                        </Column>
                                    </DataTable>
                                </div>

                                {apontamento.arquivos ?
                                    <div className="col-sm-12" style={{ display: 'flex', marginTop: 8, overflow: 'auto' }}>
                                        {
                                            apontamento.arquivos.filter(f => f.imagem && f.ativo).map((imagem, index) => {
                                                return <div key={`img${index}`} style={{ justifyContent: 'center', borderWidth: 1, borderColor: '#dadada', borderStyle: 'solid', marginLeft: 5, display: 'grid' }}>
                                                    <a className='p-lightbox-image-target' style={{ marginLeft: 'auto', cursor: 'pointer', marginRight: 'auto', width: 128, textAlign: 'center' }} onClick={() => clickImagem(index, [...apontamento.arquivos.filter(f => f.imagem && f.ativo)])}>
                                                        <img style={{ maxHeight: 128, maxWidth: 128 }} src={imagem.url} title={imagem.nome} />
                                                    </a>
                                                    <Button type="button" label="Remover" className="ui-button-info" style={{ justifyContent: 'center' }} onClick={() => removerAnexoExistente(imagem)} />
                                                </div>
                                            })
                                        }
                                    </div>
                                    : null}

                            </div>

                        </div>
                    </Panel>
                </div>
            </div>


        </BaseCadastro>
    )
}
